import React from 'react'
import USDefaultTemplate from 'src/components/template/us'
import { promoCodes } from 'src/constants/promoCodes'
import { commonSubtitleText, commonTitleText } from 'src/modules/utils/constants'

export default (props) => {
  return (
    <USDefaultTemplate
      location={props.location}
      offerBanner={{
        title: ['Special Offer Applied!', 'Enjoy 30% off 3 months of our Elite plan'],
      }}
      offerCode={promoCodes.lenovo}
      title={commonTitleText.streamLiveTVSports}
      subtitle={commonSubtitleText.onAnyDevice}
      noIndex={true}
    />
  )
}
